import React from 'react';
import ReviewItemCard from './ReviewItemCard';

const TextbookSectionCard = ({id, title, selected, onToggle, summary, pagePill}) => (
    <ReviewItemCard
        id={id}
        text={title}
        checked={selected}
        onToggle={onToggle}
        summary={summary}
        typePill={pagePill}
    />
);

export default TextbookSectionCard;
